// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tile-title[data-v-14ebd22e]{min-height:60px}.green-text[data-v-14ebd22e]{color:green}", ""]);
// Exports
module.exports = exports;
